import { useState, useEffect } from "react";
import { Bounce, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { usePostHog } from "posthog-js/react";
import { useAuthContext } from "~/hooks/useAuthContext";
import { customer } from "~/api/config";

const CookieBanner = () => {
  const { t } = useTranslation();
  const posthog = usePostHog();
  const [consentGiven, setConsentGiven] = useState(
    posthog.get_explicit_consent_status(),
  );
  const { user } = useAuthContext();

  useEffect(() => {
    posthog.register({ customer });

    posthog.setPersonPropertiesForFlags({
      customer: customer,
    });

    if (user) {
      const id = user.id;
      if (posthog.has_opted_in_capturing()) {
        posthog.identify(`${customer}-${id}`, { id });
      }
    }
  }, [posthog, user, consentGiven]);

  useEffect(() => {
    if (consentGiven === "pending") {
      const handleAccept = () => {
        posthog.opt_in_capturing();
        setConsentGiven("granted");
        toast.dismiss("cookie-banner");
      };

      const handleDecline = () => {
        posthog.opt_out_capturing();
        setConsentGiven("denied");
        toast.dismiss("cookie-banner");
      };

      toast.info(
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-lg font-bold">{t("toasts.info.cookieHeader")}</h2>
          <p>{t("toasts.info.cookieBanner")}</p>
          <div className="flex w-full gap-2">
            <Button
              className="flex-1"
              variant="secondary"
              onClick={handleAccept}
            >
              {t("commons.buttons.accept")}
            </Button>
            <Button
              className="flex-1"
              variant="outline"
              onClick={handleDecline}
            >
              {t("commons.buttons.decline")}
            </Button>
          </div>
        </div>,
        {
          toastId: "cookie-banner", // avoid duplicate toasts
          position: "bottom-right",
          autoClose: false,
          hideProgressBar: false,
          closeButton: false,
          icon: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
          className: "min-w-[24rem] max-w-xl",
        },
      );
    }
  }, [consentGiven, t, posthog]);
  return null;
};

export default CookieBanner;
